import { Link } from "@tanstack/react-router"
import { Button } from "../ui/button"
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../ui/card"

export function DefaultErrorPage({ error, resetErrorBoundary }: { error?: Error; resetErrorBoundary?: () => void }) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="font-bold text-2xl text-destructive">Something went wrong</CardTitle>
          <CardDescription>We're sorry, but an error occurred while processing your request.</CardDescription>
        </CardHeader>
        <CardContent>
          {error && (
            <div className="mt-4">
              <p className="font-medium text-gray-700 text-sm">Error Details:</p>
              <pre className="mt-2 max-h-32 overflow-auto rounded bg-gray-100 p-3 text-xs">
                {error.message || error.toString()}
              </pre>
            </div>
          )}
        </CardContent>
        <CardFooter className="flex flex-col gap-2">
          <Button asChild variant="default" className="w-full">
            <Link to="/">Go Home</Link>
          </Button>
          <Button onClick={() => resetErrorBoundary?.()} variant="outline" className="w-full">
            Try Again
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
